import { render, staticRenderFns } from "./video-upload.vue?vue&type=template&id=d77e6b5a&scoped=true&"
import script from "./video-upload.vue?vue&type=script&lang=js&"
export * from "./video-upload.vue?vue&type=script&lang=js&"
import style0 from "./video-upload.vue?vue&type=style&index=0&id=d77e6b5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77e6b5a",
  null
  
)

export default component.exports